import { render, staticRenderFns } from "./HistoryArea.vue?vue&type=template&id=20bf39c3&scoped=true"
import script from "./HistoryArea.vue?vue&type=script&lang=js"
export * from "./HistoryArea.vue?vue&type=script&lang=js"
import style0 from "./HistoryArea.vue?vue&type=style&index=0&id=20bf39c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf39c3",
  null
  
)

export default component.exports